const en: Record<string, string> = {
  'projects.title': 'Projects',
  'projects.subtitle': "The projects I'm involved with.",
  'projects.empty': 'No projects yet.',
  'projects.addProject': 'Add Project',
  'projects.editProject': 'Edit Project',
  'projects.name': 'Name *',
  'projects.description': 'Description *',
  'projects.creating': 'Creating project...',
  'projects.updating': 'Updating project...',
  'projects.createSuccess': 'Project created successfully.',
  'projects.updateSuccess': 'Project updated successfully.',
  'projects.notFound': 'Project not found',
  'projects.noProjects': 'No projects linked to this tribe yet.',
  'projects.reorderProjects': 'Order projects',
  'projects.finishReorderProjects': 'Finish ordering projects',
  'projects.moveUp': 'Move up',
  'projects.moveDown': 'Move down',
  'projects.archivedProjects': 'Archived projects',
  'projects.reactivate': 'Reactivate',
  'projects.noArchivedProjects': 'No archived projects.',
  'projects.tabTribes': 'Tribes',
  'projects.noTribesLinked': 'No tribes linked to this project.',
  'projects.descriptionOptional': 'Description',
  'projects.features': 'Features',
  'projects.tabsConfig': 'Tabs',
  'projects.archiveTitle': 'Archive this project?',
  'projects.archiveMessage':
    'This will archive "{{name}}". It will no longer be active.',

  'tribes.title': 'Tribes',
  'tribes.subtitle': "The tribes I'm involved with.",
  'tribes.createTribe': 'Tribe',
  'tribes.empty': 'No tribes yet. Create your first tribe!',
  'tribes.createTitle': 'Create a new tribe',
  'tribes.createSubtitle': 'Fill in the form below to create a new tribe',
  'tribes.updateTitle': 'Update Tribe',
  'tribes.updateSubtitle': 'Modify the tribe information below',
  'tribes.name': 'Name *',
  'tribes.tribeName': 'Tribe Name *',
  'tribes.description': 'Description *',
  'tribes.membersAndPositions': 'Members and positions',
  'tribes.membersAndPositionsHint':
    'Select persons and assign their positions. At least one Manager is required.',
  'tribes.filterPersons': 'Filter persons',
  'tribes.clearAllFilters': 'Clear all filters',
  'tribes.clearFilters': 'Clear filters',
  'tribes.showOnlySelected': 'Show only selected persons ({{count}})',
  'tribes.showingSelected': 'Showing {{count}} selected person(s)',
  'tribes.foundPersons': 'Found {{count}} person(s) matching "{{search}}"',
  'tribes.loadingPersons': 'Loading persons...',
  'tribes.noPersonsAvailable':
    'No persons available. Please create persons first.',
  'tribes.noPersonsMatch':
    'No persons match your filter. Try a different search term.',
  'tribes.noPersonsSelected':
    'No persons selected yet. Start selecting persons from the list above.',
  'tribes.noPersonsSelectedShort': 'No persons selected yet.',
  'tribes.noPersonsFound': 'No persons found.',
  'tribes.creatingTribe': 'Creating Tribe...',
  'tribes.updatingTribe': 'Updating Tribe...',
  'tribes.createWait':
    'Please wait while we create the tribe and assign members',
  'tribes.updateWait': 'Please wait while we save your changes',
  'tribes.createSuccess': 'Tribe created successfully. Redirecting...',
  'tribes.updateSuccess': 'Tribe updated successfully!',
  'tribes.noMembers': 'No members yet. Click "Edit Tribe" to add members.',
  'tribes.membersCount': 'Members ({{count}})',
  'tribes.tribesCount': 'Tribes ({{count}})',
  'tribes.attachmentsCount': 'Attachments ({{count}})',
  'tribes.download': 'Download',
  'tribes.descriptionSection': 'Description',
  'tribes.as': 'as',
  'tribes.notFound': 'Tribe not found',
  'tribes.tabDescription': 'Description',
  'tribes.tabProjects': 'Projects',
  'tribes.tabMembers': 'Members',
  'tribes.archive': 'Archive',
  'tribes.archiveConfirmTitle': 'Archive this tribe?',
  'tribes.archiveConfirmMessage':
    'This will archive "{{name}}". It will no longer appear as active.',

  'positions.manager': 'Manager',
  'positions.member': 'Member',
  'positions.guest': 'Guest',

  'projectDocuments.tab': 'Documents',
  'projectDocuments.addDocument': 'Document',
  'projectDocuments.newDocument': 'Document',
  'projectDocuments.searchPlaceholder': 'Search documents...',
  'projectDocuments.allLabels': 'All',
  'projectDocuments.noDocuments': 'No documents yet.',
  'projectDocuments.noResults': 'No documents match your search.',
  'projectDocuments.title': 'Title',
  'projectDocuments.titlePlaceholder': 'Document title...',
  'projectDocuments.titleRequired': 'Title is required',
  'projectDocuments.labels': 'Labels',
  'projectDocuments.labelsPlaceholder': 'Add labels...',
  'projectDocuments.creating': 'Creating document...',
  'projectDocuments.updating': 'Updating document...',
  'projectDocuments.notFound': 'Document not found',
  'projectDocuments.backToProject': 'Back to project',
  'projectDocuments.backToDocuments': 'Back to documents',
  'projectDocuments.archiveTitle': 'Archive this document?',
  'projectDocuments.archiveMessage':
    'This will archive "{{title}}". It will no longer appear in the documents list.',
  'projectDocuments.tocDepthLabel': 'Table of contents depth (reader view)',

  'documentPages.pages': 'Pages',
  'documentPages.addPage': 'Page',
  'documentPages.newPage': 'New Page',
  'documentPages.noPages': 'No pages yet.',
  'documentPages.title': 'Title',
  'documentPages.titlePlaceholder': 'Page title...',
  'documentPages.titleRequired': 'Title is required',
  'documentPages.creating': 'Creating page...',
  'documentPages.updating': 'Updating page...',
  'documentPages.notFound': 'Page not found',
  'documentPages.archiveTitle': 'Archive this page?',
  'documentPages.archiveMessage':
    'This will archive "{{title}}". It will no longer appear in the pages list.',
  'documentPages.read': 'Read',
  'documentPages.exitRead': 'Exit reader',
  'documentPages.pageOf': 'Page {{index}}',
  'documentPages.tableOfContents': 'Table of Contents',

  'publications.title': 'Publications',
  'publications.searchPlaceholder': 'Search publications...',
  'publications.noResults': 'No publications found.',
  'publications.publishedOn': 'Published on',
  'publications.backToList': 'Back to publications',
  'publications.notFound': 'Publication not found.',
  'publications.published': 'Published',
  'publications.publish': 'Publish',
  'publications.unpublish': 'Unpublish',
  'publications.view': 'View public page',
  'publications.publishConfirmTitle': 'Publish this document?',
  'publications.publishConfirmMessage':
    '"{{title}}" will be publicly accessible without authentication.',
  'publications.unpublishConfirmTitle': 'Unpublish this document?',
  'publications.unpublishConfirmMessage':
    '"{{title}}" will no longer be publicly accessible.',
  'publications.allTribes': 'All tribes',
  'publications.allProjects': 'All projects',
  'publications.author': 'Written by',

  'validation.tribeNameRequired': 'Tribe name is required',
  'validation.documentContentRequired': 'Document content is required',
  'validation.selectOnePerson':
    'Please select at least one person for the tribe',
  'validation.assignOneChief': 'Please assign at least one person as Chief',
  'validation.noChanges': 'No changes detected',
  'validation.failedCreateTribe': 'An error occurred while creating the tribe',
  'validation.failedUpdateTribe': 'Failed to update tribe',
};

export default en;
